import React from 'react';

import { Grid, GridItem } from '@chakra-ui/react';

import { Box, SubmitButton, Text } from '@r-client/shared/ui/core';
import { InputField } from '@r-client/shared/ui/form';
import { SafeHTML } from '@r-client/shared/util/components';

import { CreateRsvpMutation } from '../../../graphql/create-rsvp-mutation';

import styles from './form.module.scss';

export interface IFormProps {
  event: {
    id: string;
    slug: string;
    title: string;
  };
  model: CreateRsvpMutation;
  onSubmit: () => Promise<void>;
}

export const Form: React.FC<React.PropsWithChildren<IFormProps>> = ({
  model,
  event,
  onSubmit,
}) => {
  return (
    <Box>
      <Box m="0 0 1.5brm 0">
        <Text type="h4" align="center">
          {/* TODO https://linear.app/republic/issue/RCE-1324/update-eventseventtitle-output
              remove SafeHTML after fixind the issue
          */}
          RSVP for <SafeHTML sanitizedHtml={event.title} component="span" />
        </Text>
      </Box>

      <Grid templateColumns="repeat(24, 1fr)" gap={4}>
        <GridItem colSpan={{ base: 24 }}>
          <Box m="0 0 1brm 0">
            <InputField
              htmlId="user-full-name"
              field={model.fields.fullName}
              inputGroupProps={{
                label: 'Full name',
              }}
            />
          </Box>
        </GridItem>

        <GridItem colSpan={{ base: 24 }}>
          <Box m="0 0 1brm 0">
            <InputField
              htmlId="user-email"
              field={model.fields.email}
              inputGroupProps={{
                label: 'Email',
              }}
            />
          </Box>
        </GridItem>

        <GridItem colSpan={{ base: 24, sm: 12 }}>
          <Box m="0 0 1brm 0">
            <InputField
              htmlId="user-linkedin-url"
              placeholder="(Optional)"
              field={model.fields.linkedinUrl}
              inputGroupProps={{
                label: 'Linkedin url',
              }}
            />
          </Box>
        </GridItem>

        <GridItem colSpan={{ base: 24, sm: 12 }}>
          <Box m="0 0 1brm 0">
            <InputField
              htmlId="user-phone-number"
              placeholder="(Optional)"
              field={model.fields.phoneNumber}
              inputGroupProps={{
                label: 'Phone number',
              }}
            />
          </Box>
        </GridItem>
      </Grid>

      <Box m="1brm 0 0 0" className={styles.submitButtonWrapper}>
        <SubmitButton onSubmit={onSubmit}>Confirm RSVP</SubmitButton>
      </Box>
    </Box>
  );
};
